import axios from 'axios';

axios.defaults.timeout = 30000;
axios.defaults.headers['Content-type'] = 'application/json';
